import { isIterable } from "@thi.ng/checks/is-iterable";
import { compR } from "./compr.js";
import { iterator1 } from "./iterator.js";
function drop(n, src) {
  return isIterable(src) ? iterator1(drop(n), src) : (rfn) => {
    const r = rfn[2];
    let m = n;
    return compR(
      rfn,
      (acc, x) => m > 0 ? (m--, acc) : r(acc, x)
    );
  };
}
export {
  drop
};
